import type {
  PlataformaDePublicacaoDto,
  PublicacaoDto,
} from "@base/contracts";

/**
 * Edição de um card da agenda (uma publicação por rede).
 * Post já publicado (ou indo para a rede) fica como está: não edita nem sai.
 */

export function podeEditarPublicacao(p: PublicacaoDto): boolean {
  return p.status !== "publicado" && p.status !== "scheduled";
}

export type PlanoEdicaoGrupo = {
  /** Continuam no grupo e recebem o conteúdo novo. */
  readonly editar: readonly PublicacaoDto[];
  /** Rede desmarcada: sai da agenda. */
  readonly remover: readonly PublicacaoDto[];
  /** Rede marcada que não existia no grupo: post novo. */
  readonly criar: readonly PlataformaDePublicacaoDto[];
  /** Já foram para a rede: não mudam. */
  readonly travadas: readonly PublicacaoDto[];
};

export function planejarEdicaoDoGrupo(
  itens: readonly PublicacaoDto[],
  plataformas: readonly PlataformaDePublicacaoDto[],
): PlanoEdicaoGrupo {
  const escolhidas = new Set(plataformas);
  const travadas = itens.filter((p) => !podeEditarPublicacao(p));
  const editaveis = itens.filter(podeEditarPublicacao);
  const existentes = new Set(itens.map((p) => p.plataforma));
  return {
    editar: editaveis.filter((p) => escolhidas.has(p.plataforma)),
    remover: editaveis.filter((p) => !escolhidas.has(p.plataforma)),
    criar: [...escolhidas].filter((pl) => !existentes.has(pl)),
    travadas,
  };
}
